import React from "react";
import { Routes, Route } from "react-router-dom";
import SignUp from "./signUp";
import SignIn from "./signIn";
import Forgot from "./forgot";
import Auth from "./auth";
import SetPassword from "./setPassword";
import NotFound from "./notFound";
import ChangePassword from "./changePassword"
function AuthMain() {
  return (
    <Routes>
      <Route path="/" element={<Auth />}>
        <Route path="signin" element={<SignIn />} />
        <Route path="signup/shahzebkhan@iquanta.pro" element={<SignUp />} />
        <Route path="forgot" element={<Forgot />} />
        <Route path="forgot/verify/:email/:token" element={<SetPassword />} />
        <Route path="change/password" element={<ChangePassword />} />

        <Route path="*" element={<NotFound />} />

      </Route>


    </Routes>
  );
}

export default AuthMain;
